import * as React from 'react';
import { translate } from '@estee/elc-service';
import { observer } from 'mobx-react';
import { ResponsiveModal } from '@estee/elc-responsive-modal';
import { Button } from '@estee/elc-buttons';
import { RemoveIcon } from '@estee/elc-icons';
import { SUPPORTED_BROWSER_OVERLAY_COPY } from '../../../constants/DataTestIdAttributes';

interface ISupportedBrowserOverlay {
    translations: {
        useSafariToAccessCamera: string;
    };
    closeOverlay(): void;
    isOpen: boolean;
}

export const SupportedBrowserOverlay = translate(['useSafariToAccessCamera'])(
    observer(({ translations, closeOverlay, isOpen }: ISupportedBrowserOverlay) => {
        const { useSafariToAccessCamera } = translations;

        return (
            <ResponsiveModal
                isOpen={isOpen}
                className="elc-supported-browser-overlay"
                deactivateModal={closeOverlay}
                onMaskClick={closeOverlay}
                underlayClickExits={false}
                title={useSafariToAccessCamera}
            >
                <Button onClick={closeOverlay} className="elc-supported-browser-overlay__button">
                    <RemoveIcon />
                </Button>
                <div
                    dangerouslySetInnerHTML={{ __html: useSafariToAccessCamera }}
                    className="elc-supported-browser-overlay__copy"
                    data-test-id={SUPPORTED_BROWSER_OVERLAY_COPY}
                />
            </ResponsiveModal>
        );
    })
);
